import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { LatencyIcon } from '../icons';
import { Toggle } from './Toggle';
import styles from './LatencyToggle.module.css';

export function LatencyToggle() {
  const { store, eventBus } = usePlayerContext();
  const latencyMode = useStore(store, useCallback(s => s.latencyMode, []));
  const llhlsAvailable = useStore(store, useCallback(s => s.llhlsAvailable, []));
  const isSwitching = useStore(store, useCallback(s => s.isSwitching, []));

  const handleChange = useCallback(() => {
    if (store.getState().isSwitching) return;
    const current = store.getState().latencyMode;
    eventBus.emit('latency:mode', current === 'low' ? 'normal' : 'low');
  }, [eventBus, store]);

  // Hide if LL-HLS was never available for this stream
  if (!llhlsAvailable) return null;

  const isLow = latencyMode === 'low';

  return (
    <div
      className={`${styles.row}${isSwitching ? ` ${styles.disabled}` : ''}`}
      role="button"
      tabIndex={isSwitching ? -1 : 0}
      aria-disabled={isSwitching}
      onClick={handleChange}
      onKeyDown={event => {
        if (isSwitching) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleChange();
        }
      }}
    >
      <span className={styles.icon}><LatencyIcon /></span>
      <span className={styles.label}><span className={styles.labelText}>{isSwitching ? 'Переключение…' : 'Низкая задержка'}</span></span>
      <Toggle checked={isLow} onChange={handleChange}/>
    </div>
  );
}
